import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import { useTranslation } from 'react-i18next';

import css from './OrdersOrdersListComponent.module.css';
import {ordersActions} from "../../../store/slices/orders-slices";
import OrdersSingleOrderComponent from "../OrdersSingleOrderComponent/OrdersSingleOrderComponent";
import OrderDetails from "../ordersSectionModals/OrderDetails/OrderDetails";
import {Pagination} from "../../../ui";
import Loader from "../../ui/Loader/Loader";


const OrdersOrdersListComponent = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const {ordersA, trigger, filterParams, status} = useSelector(store => store.orders);
    const {page} = useSelector(store => store.pagination);

    const [isOpenModalInfo, setIsOpenModalInfo] = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState(null);

    const {totalPages, orders, total} = ordersA || {};

    useEffect(() => {
        dispatch(ordersActions.getAllOrders({page, ...filterParams}));
    }, [trigger, page, filterParams]);

    // Show loading state when status is Loading or when ordersA is undefined (initial load)
    const isLoading = status === "Loading" || !ordersA;

    return (
        <div className={css.wrap}>
            <div className={css.header}>
                <div className={css.order}>{t('order')}</div>
                <div className={css.contact}>{t('contact')}</div>
                <div className={css.name}>{t('name')}</div>
                <div className={css.dietType}>{t('diet-type')}</div>
                <div className={css.createdAt}>{t('created')}</div>
                <div className={css.paid}>{t('paid')}</div>
                <div className={css.unpaid}>{t('unpaid')}</div>
                <div className={css.debit}>{t('debt')}</div>
                <div className={css.paymentStatus}>{t('payment-status')}</div>
                <div className={css.paymentMethod}>{t('payment-method')}</div>
            </div>

            <div className={css.ordersContainer}>
                {isLoading ? (
                    <div className={css.loadingContainer}>
                        <Loader text={t("Loading orders...")} />
                    </div>
                ) : status === "rejected" ? (
                    <div className={css.noResults}>{t("Error loading orders")}</div>
                ) : orders && orders.length > 0 ? (
                    orders.map(obj => (
                        <OrdersSingleOrderComponent
                            key={obj.id}
                            obj={obj}
                            setIsOpenModalInfo={setIsOpenModalInfo}
                            setSelectedOrderId={setSelectedOrderId}
                        />
                    ))
                ) : (
                    <div className={css.noResults}>
                        {filterParams.word || filterParams.startDate || filterParams.endDate || filterParams.status?.length > 0 
                            ? t("No orders found matching your filters") 
                            : t("No orders available")}
                    </div>
                )}
            </div>

            <div className={css.blockPagination}>
                <Pagination totalPages={totalPages || 0} totalItems={total || 0}/>
            </div>

            {isOpenModalInfo && <OrderDetails
                setIsOpenModalInfo={setIsOpenModalInfo}
                selectedOrderId={selectedOrderId}
            />}
        </div>
    );
};

export default React.memo(OrdersOrdersListComponent);
